export const DEFINE_AUDIENCE_READ_ONLY_TOOLTIP = 'read-only-define-audience-tooltip';
export const DEFINE_AUDIENCE_TRIGGER_SELECT = 'define-audience-select-trigger';
export const DEFINE_AUDIENCE_SELECT_ID = 'define-audience-select-trigger-data';
export const DEFINE_AUDIENCE_SELECT_VIEW_LIST_LINK = 'define-audience-select-view-list-link';
export const DEFINE_CRITERIA_BUTTON = 'define-criteria-button';
export const DEFINE_CRITERIA_BUTTON_COUNTER_BADGE = 'define-criteria-button-counter-badge';
export const DEFINE_CRITERIA_DELETE_BUTTON = 'define-criteria-delete-button';
